// extracted by mini-css-extract-plugin
export default {"main":"noRecords_main__Kmk4c","innerdiv":"noRecords_innerdiv__oOiYU","magnigyingGlass":"noRecords_magnigyingGlass__yBvBP","emptyText":"noRecords_emptyText__LlbSR"};